import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {DatePipe} from '@angular/common';
import { AngularCustomMaterialModule } from './angular-custom-material/angular-custom-material.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MembershipPaymentService } from './services/membership-payment.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { MembershipPaymentComponent } from './membership-payment/membership-payment.component';
import { FooterComponent } from './footer/footer.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { MatDialogModule,  } from '@angular/material/dialog';
import { PhoneMaskDirective } from './phone-mask.directive';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxStripeModule } from 'ngx-stripe';
import { InsurnceComponent } from './insurnce/insurnce.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import {MatTooltipModule} from '@angular/material';
import { PhysicalLocationComponent } from './dailog/physical-location/physical-location.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    MembershipPaymentComponent,
    FooterComponent,
    SubscriptionsComponent,
    PhoneMaskDirective,
    ConfirmDialogComponent,
    InsurnceComponent,
    PhysicalLocationComponent  
  ],
    entryComponents: [
    ConfirmDialogComponent,
    PhysicalLocationComponent
  ],
  imports: [
    BrowserModule,
    AngularCustomMaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    AppRoutingModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    // NgxStripeModule.forRoot('pk_live_51HYufXJZTw6WxXg4YyoVcrUJ1UkxkH6FlC9qCBiI2LnuWcVSwTqqeBMECqMUk8aBxS5HRXPtrADMRxTmxqH3aWGj00QnbvtMWE'),
    NgxStripeModule.forRoot('pk_test_51HYo8JIU6EOWyLAQKryyrgURPOR8bSywVMs6BvBkVmhFOCijgB5bCKJQYOvhjSR5Q29tJCQC8XrM1jMwemx2ofrg00IdhDUVqJ'),
  ],
  exports: [
    PhoneMaskDirective,
    MatMomentDateModule
  ],
  providers: [MembershipPaymentService, DatePipe, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
  { provide: MAT_DATE_FORMATS, useValue: {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'MM-DD-YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY'
    }
} },

],
  bootstrap: [AppComponent]
})

export class AppModule { }
